import "../../index13.css";
import { jsx as n, jsxs as e } from "react/jsx-runtime";
import { _ as a } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import l from "../Spinner/index.js";
const m = "_block-loading_1jl3q_1", _ = "_spinner_1jl3q_7", p = "_inner_1jl3q_11", d = "_with-border_1jl3q_21", h = "_compact_1jl3q_28", o = {
  blockLoading: m,
  spinner: _,
  inner: p,
  withBorder: d,
  compact: h
};
function q(r) {
  const {
    className: c,
    message: s,
    compact: i,
    withoutBorder: t = !1
  } = r;
  return /* @__PURE__ */ n(
    "div",
    {
      className: a(
        o.blockLoading,
        i && o.compact,
        !t && o.withBorder,
        c
      ),
      children: /* @__PURE__ */ e("div", { className: o.inner, children: [
        /* @__PURE__ */ n(l, { className: o.spinner }),
        s
      ] })
    }
  );
}
export {
  q as default
};
